/**
 * Guia Essencial - Constantes de Identidade Visual
 * 
 * Este arquivo centraliza todas as informações de branding do projeto.
 * Use estas constantes ao invés de valores hardcoded em componentes.
 */

export const BRAND = {
  // Identidade Básica
  name: "Guia Essencial",
  shortName: "Guia Essencial",
  slogan: "Sua jornada por uma vida mais saudável",
  description: "Óleos Essenciais e Vida Natural",
  
  // Storage Keys (para localStorage)
  storagePrefix: "guia-essencial",
  themeStorageKey: "guia-essencial-theme",
  
  // Cores do Design System (referência - usar classes Tailwind nos componentes)
  // Estas cores correspondem às variáveis CSS em index.css
  colors: {
    // Cores Principais
    primary: "hsl(152, 56%, 20%)",        // --primary (Forest Green)
    primaryForeground: "hsl(42, 33%, 98%)",
    secondary: "hsl(140, 20%, 90%)",      // --secondary (Sage)
    accent: "hsl(38, 70%, 55%)",          // --accent (Gold)
    
    // Fundos
    background: "hsl(42, 33%, 98%)",      // --background (Cream)
    foreground: "hsl(150, 30%, 15%)",     // --foreground
    muted: "hsl(42, 25%, 93%)",           // --muted
    
    // Segurança
    safe: "hsl(142, 70%, 32%)",           // --safe
    caution: "hsl(45, 95%, 45%)",         // --caution
    danger: "hsl(0, 72%, 45%)",           // --danger
    
    // Destrutivo/Alerta
    destructive: "hsl(0, 65%, 55%)",      // --destructive
    warning: "hsl(45, 95%, 50%)",         // --warning
  },
  
  // Tipografia (referência - usar classes Tailwind)
  fonts: {
    display: "'Playfair Display', Georgia, serif",
    body: "'Inter', system-ui, sans-serif",
  },
  
  // Assets
  assets: {
    favicon: "/favicon.png",
    ogImage: "/og-image.png",
    logo: "/favicon.png", // Usando favicon como logo por enquanto
  },
  
  // SEO
  seo: {
    title: "Guia Essencial - Óleos Essenciais",
    titleTemplate: "%s | Guia Essencial",
    description: "Seu guia completo de óleos essenciais para uma vida mais saudável e natural. Calculadora de diluição, receitas e informações seguras.",
    keywords: [
      "óleos essenciais",
      "aromaterapia", 
      "vida natural",
      "saúde natural",
      "receitas naturais",
      "calculadora de diluição",
    ],
  },
  
  // Informações Legais
  legal: {
    author: "Equipe Guia Essencial",
    year: new Date().getFullYear(),
    disclaimer: "As informações deste site são apenas para fins educacionais e não substituem orientação médica profissional.",
  },
  
  // Contato/Redes Sociais (preencher quando disponível)
  social: {
    instagram: "",
    facebook: "",
    youtube: "",
    email: "",
  },
} as const;

// Tipo para autocomplete
export type Brand = typeof BRAND;
